import { rem } from 'polished'
import React from 'react'
import { useInView } from 'react-intersection-observer'
import styled from 'styled-components'

import Image from 'components/Common/Image/Image'
import { StyledModalContent } from 'LuxKit/Modal/ModalContent'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { usePlaceImageName } from 'tripPlanner/hooks/Google/usePlaceImageName'

export const StyledExploreModalImage = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;

  & + ${StyledModalContent} {
    margin-top: ${rem(20)};

    ${mediaQueryUp.tablet} {
      margin-top: ${rem(24)};
    }
  }
`

const BgImg = styled.div`
  position: absolute;
  /* Expand it so the edges are cropped out. This is to avoid white colour at the edges caused by the blurring. */
  width: 120%;
  height: 120%;
  top: -10%;
  left: -10%;
  object-fit: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  filter: blur(16px);
`

const MainImg = styled(Image)`
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: contain;
`

interface Props {
  photoName: string
  className?: string
}

/**
 * Based on ModalImageThumbnail from LuxKit
 * */
function ExploreModalImage({ className, photoName }: Props) {
  const [inViewRef, inView] = useInView({ triggerOnce: true })
  const { data } = usePlaceImageName({
    name: photoName,
    options: { enabled: inView },
  })
  const imageUrl = data?.url
  return (
    <StyledExploreModalImage className={className} ref={inViewRef}>
      <BgImg style={{ backgroundImage: `url(${imageUrl})` }} />
      {imageUrl && <MainImg image={{ url: imageUrl }} />}
    </StyledExploreModalImage>
  )
}

export default ExploreModalImage
